import React, {memo} from "react";
import dayjs from 'dayjs';
import TransactionLink from "../../../../TransactionLink";

function Date(props) {
    const { record } = props;

    switch (record.lineType) {
        case 'heading':
            return <span className="BaseTable__row-cell-text heading">{record.label}</span>;
        case 'summary_total':
            return <span className="BaseTable__row-cell-text summary-total">{record.label}</span>;
        case 'spacer':
            return null;
        case 'reconciled_transaction': {
            const label = dayjs(record.date).format('DD/MM/YYYY');
            return <TransactionLink transaction={record} label={label} />;
        }
        case 'reconciled_transaction_total': {
            return (
                <span className="BaseTable__row-cell-text reconciled-transaction-total">{record.label}</span>
            );
        }
        default: {
            const label = dayjs(record.date).format('DD/MM/YYYY');
            return (
                <span className="BaseTable__row-cell-text date">
                    <TransactionLink transaction={record} label={label} />
                </span>
            );
        }
    }
}
export default memo(Date);
